
<div class="jumbotron jumbotron-fluid memic-banner" style="background-color: rgb(0, 154, 166)">
  <div class="memic-banner__wrapper">
    <div class="memic-banner__body">
      <div class="memic-banner__body__inner">
        <h1 class="display-4" style="color: white !important;">E-Ergo Home</h1>
        <p class="lead" style="color: white !important;">To reduce your risk of injury, practice these safety tips</p>
      </div>
    </div>
    <img class="memic-banner__image" src="/assets/images/E-ErgoPageHeader.jpg">
  </div>
</div>
<ol class="breadcrumb">
  <li><a [routerLink]="['/home']">Home</a></li>
  <li class="active">E-Ergo</li>
</ol>
<div class="row">
  <div class="col-md-12">
    <div class="memic-panel panel">
      <div class="panel-heading">
        <h3 class="panel-title">
          E-Ergo™️: Ergonomics at Your Fingertips
        </h3>
      </div>
      <section class="panel-body">
        <section>
          <div class="row p-y-3">
            <div class="col-sm-8">
              <h4 class="memic-e-ergo--title">
                Work injury prevention and product quality all improve with good workstation design.
              </h4>
              <p>
                Free to our policyholders, MEMIC’s E-Ergo™️ conveniently provides the tools and solutions to overcome everyday ergonomic challenges in the office, manufacturing, healthcare and manual material handling work environments. In a competitive world economy, fixing the problem right now is essential and improving worker comfort and efficiency is key to a healthy and successful business.
              </p>
              <h4 class="memic-e-ergo--title">Select your work setting or environment below and follow the instructions provided.</h4>
              <div class="accordion" id="eErgoEnvironment">

                <div class="m-b-3">
                  <div class="memic-e-ergo-accordion--header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#manualMaterialHandling" aria-expanded="false" aria-controls="manualMaterialHandling">
                      <h5>Manual Material Handling</h5>
                    </button>
                    <div class="row">
                      <div class="col-sm-8">
                        <p>Is it dynamic work, which requires lifting and moving objects repeatedly while standing or seated? Examples include order picker, manufacturing line, food processing, landscaping, housekeeping, loading and unloading, construction.</p>
                      </div>
                      <div class="col-sm-4">
                        <img src="../../../assets/images/dynamic-work.jpg">
                      </div>
                    </div>
                  </div>

                  <div id="manualMaterialHandling" class="accordion-collapse collapse" data-bs-parent="#eErgoEnvironment">

                    <div class="panel memic-panel memic-panel--gray p-a-3">

                      <a target="_blank" class="btn memic-btn memic-btn--default m-r-3 m-b-3" href="https://safetydirector.blob.core.windows.net/e-ergo-assets/Manual%20Material%20Handling%20E-Ergo%20Request%20Form%20SD.doc">Download Request Form</a>
                      <a class="btn memic-btn memic-btn--default m-b-3" href="mailto:LCOps@memic.com?subject=MEMIC Industrial Hygiene Review Request">Email Your Info</a>

                      <h3>Video Assessment Instructions:</h3>
                      <a name="Videos"></a>
                      <ol style="margin-left:50px">
                        <li>Download the <a target="_blank" href="https://safetydirector.blob.core.windows.net/e-ergo-assets/Manual%20Material%20Handling%20E-Ergo%20Request%20Form%20SD.doc">Manual Material Handling E-Ergo™ Request Form</a></li>
                        <li>Record digital video based on the instructions below.</li>
                        <li>Complete the form, being sure to fill out the "Critical Demands of Job Tasks" section.</li>
                        <li>Submit the completed form, <u><em>without video</em></u>, to <a href="mailto:LCOps@memic.com?subject=MEMIC Industrial Hygiene Review Request">LCOps@memic.com.</a></li>
                        <li>You will receive an email with video upload instructions.</li>
                        <li>Our Ergo Team will review the information and an electronic report with analysis will be emailed back to you.</li>
                      </ol>
                      <br>

                      <div id="video-notes">
                        <h3>Video Notes:</h3>
                        <ol style="margin-left:50px">
                          <li>All video clips should show three work cycles and be one to five minutes in length.</li>
                          <li>
                            Video of work cycle must show:
                            <ol type="a">
                              <li>Profile: showing the worker performing the work with the camera to the side</li>
                              <li>Behind/Rear: showing the worker performing work with the camera behind</li>
                              <li>The entire person (head to feet)</li>
                            </ol>
                          </li>
                          <li>Videos should not have other workers in frame or background</li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </div>



                <div class="m-b-3">
                  <div class="memic-e-ergo-accordion--header">
                    <button class="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#officeErgonomics" aria-expanded="false" aria-controls="officeErgonomics">
                      <h5>Office Ergonomics</h5>
                    </button>
                    <div class="row">
                      <div class="col-sm-8">
                        <p>Is it stationary work, which requires sitting or standing in place for periods of time? Examples include bank teller, computer workstation user, driver, any work done primarily at a desk or workstation, such as accounting, HR, data entry.</p>
                      </div>
                      <div class="col-sm-4">
                        <img src="../../../assets/images/stationary-work.jpg">
                      </div>
                    </div>

                  </div>

                  <div id="officeErgonomics" class="accordion-collapse collapse" aria-labelledby="#eErgoEnvironment">

                    <div class="panel memic-panel memic-panel--gray p-a-3">

                      <a target="_blank" class="btn memic-btn memic-btn--default m-r-3 m-b-3" href="https://safetydirector.blob.core.windows.net/e-ergo-assets/OfficeErgonomicsE-ErgoRequestForm2024.pdf">Download Request Form</a>
                      <a class="btn memic-btn memic-btn--default m-b-3" href="mailto:LCOps@memic.com?subject=MEMIC Office Ergonomics Review Request">Email Your Info</a>

                      <h3>Photo Assessment Instructions</h3>
                      <a name="Photos"></a>
                      <ol style="padding:0px 5px 5px 30px;">
                        <li>Download the <a target="_blank" href="https://safetydirector.blob.core.windows.net/e-ergo-assets/OfficeErgonomicsE-ErgoRequestForm2024.pdf">Office Ergonomics E-Ergo™ Request Form.</a></li>
                        <li>Take digital camera photos of your employee's workstation while the employee is working, based on the form’s instructions. See notes below.</li>
                        <li>Submit the completed form and photos to <a href="mailto:LCOps@memic.com?subject=MEMIC Office Ergonomics Review Request">LCOps@memic.com.</a></li>
                        <li>Our Ergo Team will review the information, and an electronic report with analysis will be emailed back to you.</li>
                      </ol>
                      <br>

                      <div id="photo-assessment">
                        <h5>Photo Requirements</h5>
                        <ol style="margin-left:50px">
                          <li>
                            JPEG, JPG, PNG, or TIFF
                            <ol type="a">
                              <li>There is no requirement that images are high resolution (high pixel count).</li>
                              <li>All photos must be included as separate attachments (NOT embedded into the form).</li>
                            </ol>

                          </li>
                          <li>Show a full profile shot (i.e., from the top of the employee's head down to the feet).</li>
                          <li>Camera lens positioned at the employee's eye level to represent the employee's perspective.</li>
                        </ol>

                        <h5>Photos Needed</h5>
                        <ol style="margin-left:50px">
                          <li>Side of the worker when they are using the mouse;</li>
                          <li>Side of the worker when they are using the keyboard;</li>
                          <li>Behind the worker, of the workstation with employee removed;</li>
                          <li>Profile of the worker sitting in a working neutral posture with the work surface in the image. </li>
                        </ol>


                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-sm-4">
              <p class="memic-e-ergo--description">
                <img class="" src="../../../assets/images/ergo-1.jpg">
              </p>
            </div>
          </div>
        </section>

      </section>
    </div>
  </div>
</div>
